import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { Alert, Container } from 'react-bootstrap'
import { fetchIndividualEstimate } from 'actions/individualEstimateActions'
import { fetchIndividualEstimate as fetchIndividualEstimateConsultant } from 'actions/consultantIndividualEstimateActions'
import withLocation from '../../withLocation'
import { ResetProceedEstimateErrorMessage } from 'actions/proceedEstimateActions'
import Layout from 'layout'
import ConsultantLayout from 'consultantLayout'
import { httpVerbConstants } from 'constants/actionTypes'
import { useLocation } from 'react-router-dom'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
  checkConsultant,
} from 'helpers'
import EstimateDetails from './estimateDetails'

const IndividualEstimateScreen = ({
  match,
  accessToken,
  isAuthenticated,
  isFetching,
  opportunityId,
  dispatch,
  carData,
  summaryData,
  endOfLeaseData,
  runningData,
  financialInclusionData,
  bannerData,
  isEstimateValid,
  estimate,
  errorMessage,
  isGov,
  applicationRoles,
  releaseData,
}) => {
  let headers = { accessToken: accessToken }
  const { isConsultant } = applicationRoles
  const userEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:estimates:view' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:estimates:view' },
        },
      })
    }
  }
  const consultantEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:consultant:estimates:view' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:consultant:estimates:view' },
        },
      })
    }
  }
  const customEvents = () => {
    checkConsultant() ? consultantEvents() : userEvents()
  }
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const urlestimateID = location.pathname.substring(proposalIndex + 1)
  const callUser = () => {
    dispatch(
      fetchIndividualEstimate(
        opportunityId,
        match.params.estimateId,
        false,
        true
      )
    )
    dispatch(ResetProceedEstimateErrorMessage())
  }
  const callConsultant = () => {
    dispatch(
      fetchIndividualEstimateConsultant(
        opportunityId,
        match.params.estimateId,
        headers,
        httpVerbConstants.HTTP_GET
      )
    )
    dispatch(ResetProceedEstimateErrorMessage())
  }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      checkConsultant() ? callConsultant() : callUser()
      customEvents()
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view estimate details',
          label: 'view estimate details',
        },
      },
    })
    let notificationElement = document.getElementById('notification')
    if (notificationElement !== undefined && notificationElement !== null) {
      if (isEstimateValid) {
        document.getElementById('notification').style.display = 'none'
      } else {
        document.getElementById('notification').style.display = 'block'
      }
    }
  }, [])

  let userEmployer = useSelector((state) => state.user.employer)

  var novatedLeaseData = {
    proposalEstimate: estimate,
    userEmployer: userEmployer,
  }

  const { vehicle, isValid } = estimate

  const isError = errorMessage || false

  return isError ? (
    <>
      <div className="bg-triangle" />
      <Container className="notfound-container p-5 mb-5 bg-white shadow-sm">
        <Alert variant="danger">{errorMessage}</Alert>
      </Container>
    </>
  ) : isFetching ? (
    <div className="mt-5 mb-5 d-flex justify-content-center">
      <img src="/images/loader.gif" alt="" />
    </div>
  ) : isConsultant ? (
    <ConsultantLayout>
      <EstimateDetails
        isConsultant
        bannerData={bannerData}
        isValid={isValid}
        vehicle={vehicle}
        carData={carData}
        summaryData={summaryData}
        runningData={runningData}
        financialInclusionData={financialInclusionData}
        isGov={false}
        endOfLeaseData={endOfLeaseData}
        novatedLeaseData={novatedLeaseData}
        isEstimateValid={isEstimateValid}
        releaseData={releaseData}
      />
    </ConsultantLayout>
  ) : (
    <Layout>
      <EstimateDetails
        bannerData={bannerData}
        isValid={isValid}
        vehicle={vehicle}
        carData={carData}
        summaryData={summaryData}
        runningData={runningData}
        financialInclusionData={financialInclusionData}
        isGov={false}
        endOfLeaseData={endOfLeaseData}
        novatedLeaseData={novatedLeaseData}
        isEstimateValid={isEstimateValid}
        releaseData={releaseData}
      />
    </Layout>
  )
}

function mapStateToProps(state, ownProps) {
  const applicationRoles = state.applicationRoles
  const accessToken = state.auth.accessToken
  const isAuthenticated = checkConsultant()
    ? state.auth.isAuthenticated
    : state.authentication.isAuthenticated
  const opportunityId = checkConsultant()
    ? state.opportunity.opportunityId
    : state.authentication.opportunityId

  const {
    firstName: userFirstName,
    employer: { payFrequency, employerGRS, grossAnnualSalary } = {},
  } = state.user
  const channel = state.opportunity.channel

  const { firstName: consultantFirstName } = state.consultant
  const estimate = state.individualEstimate.estimate || {}
  const brand = state.opportunity.brand
  let isExGST = (employerGRS && employerGRS.gstExclusiveDeductionsCode && employerGRS.gstExclusiveDeductionsCode === 'Yes') ? true : false
  const isTaxShare = estimate.taxShare === 'Yes'
  const negativeEquityAmount =
    state.estimates &&
    state.estimates.tradeIn &&
    state.estimates.tradeIn.negativeEquityAmount
  const { isFetching } = state.individualEstimate
  const errorMessage = (
    (state.individualEstimate && state.individualEstimate.errorMessage) ||
    ''
  )

    .replace('500', '')
    .replace('400', '')
    .replace('404', '')
  const {
    //car
    vehicle = {},
    onRoadcost,
    priveawayPrice,
    amTotalExGST,
    tpoTotalExGST,
    basePriceNoVehicle,
    financeAmount,
    gstCreditClaimable,
    totalVehicleExGST,
    totalVehicleGST,
    totalVehicleValueExGST,
    luxuryCarTax,
    //summary
    leaseTermYears,
    leaseTerm,
    carRepaymentPerPayIncGST,
    carRepaymentPerPayExGST,
    totalPackagePerPayIncGST,
    totalPackagePerPayExGST,
    totalPackagePerPayExGSTTaxShare,
    runningCostsPerPayIncGST,
    runningCostsPerPayExGST,
    runningCostsPerPayExGSTTaxShare,
    savingsPerPay,
    outOfPocketPerPay,
    fuelBudget,
    tyresBudget,
    incidentalsBudget,
    registrationBudget,
    scheduleMaintenanceBudget,
    roadsideAssistanceBudget,
    compInsRenewalBudget,
    takeHomePerPay,
    grossSalaryPerPay,
    preTaxPerPay,
    spPreTaxDeduction,
    otherPreTaxPerPay,
    preTaxDeduction,
    taxSharePerPay,
    spTaxShareDeduction,
    netSalaryPerPay,
    netSalaryPerAnnum,
    taxMedicarePerPay,
    spTaxAndMedicare,
    netIncomePerPay,
    spNetCashSalary,
    postTaxPerPay,
    specm,
    otherPostTaxPerPay,
    postTaxDeduction,
    spCashinhand,
    lifeOfLeaseTaxSaving,
    gstSavingsOnRunningCosts,
    //running
    kmPerAnnum,
    fuelPerPayExGST,
    fuelPerPayIncGST,
    tyresPerPayExGST,
    tyresPerPayIncGST,
    roadsidePerPayExGST,
    roadsidePerPayIncGST,
    maintenancePerPayExGST,
    maintenancePerPayIncGST,
    incidentalsPerPayExGST,
    incidentalsPerPayIncGST,
    fuelPerAnnumExGST,
    fuelPerAnnumIncGST,
    tyresPerAnnumExGST,
    tyresPerAnnumIncGST,
    roadsidePerAnnumExGST,
    roadsidePerAnnumIncGST,
    maintenancePerAnnumExGST,
    maintenancePerAnnumIncGST,
    incidentalsPerAnnumExGST,
    incidentalsPerAnnumIncGST,
    costsPerPayIncGST,
    costsPerPayExGST,
    regoInsPerPayExGST,
    regoInsPerPayIncGST,
    regoPerPayIncGST,
    regoPerAnnumIncGST,
    compInsPerPayExGST,
    compInsPerPayIncGST,
    compInsPerAnnumExGST,
    compInsPerAnnumIncGST,
    totalChargesPerPayExGST,
    totalChargesPerPayIncGST,
    totalChargesPerPayIncGSTTaxShare,
    totalChargesPerPayExGSTTaxShare,
    nlFeePerPayExGST,
    nlFeePerPayIncGST,
    spFeePerPayExGST,
    spFeePerPayIncGST,
    fbtPerPay,
    lcdaPerPay,
    erSharePerPay,
    gstOnECMPerPay,
    greenfleetPerPay,
    erAdminFeePerPay,
    nlFeePerAnnumExGST,
    nlFeePerAnnumIncGST,
    spFeePerAnnumExGST,
    spFeePerAnnumIncGST,
    fbtPerAnnum,
    lcdaPerAnnum,
    taxSavings, // erSharePerAnnum,
    gstOnECMPerAnnum,
    greenfleetPerAnnum,
    erAdminFeePerAnnum,
    fbtMethod,
    noOfTyresBudget,
    compInsurance,
    mmsgDocumentFee,
    compInsurancePremium,
    leaseProtectionPremium,
    extendedWarrantyPremium,
    gapCoverPremium,
    rpcPremium,
    rpcProvider,
    leaseResidualAmountIncGST,
    residualPCT,
    annualRate,
    leaseProtection,
    rpc,
    extendedWarranty,
    extendedWarrantyProvider,
    gapCover,
    nlQuoteNumber,
    totalOnroads,
    totalExGSTNoVehicle,
    isValid,
    vehicleDescription,
    estimateId: id,
    vehicleType,
    fuelPricePerLitre,
    financierEstablishmentFee,
    roadsideAssist,
    extendedWarrantyTerm,
    maintenanceProfile,
    isIndicativeProposal,
    electricityBudget,
    electricityCostPerKm,
    electricityPerPayIncGST,
    electricityPerAnnumIncGST,
    electricityPerPayExGST,
    electricityPerAnnumExGST,
    currentNLOutOfPocketCostPerPay,
    vehicleLeaseValue,
    vehicleFBTValue,
    productId,
    overTheCapMethod,
    compInsurancePremiumFinanced,
    compInsuranceProvider,
  } = estimate

  const { year, make, family } = vehicle

  const isEstimateValid = isValid

  const financialInclusionData = {
    ...vehicle,
    financeAmount,
    compInsurance,
    priveawayPrice,
    mmsgDocumentFee,
    compInsurancePremium,
    leaseProtectionPremium,
    rpcPremium,
    rpcProvider,
    extendedWarrantyPremium,
    gapCoverPremium,
    annualRate,
    leaseTermYears,
    leaseProtection,
    rpc,
    extendedWarranty,
    extendedWarrantyProvider,
    gapCover,
    brand,
    consultantFirstName,
    userFirstName,
    stampDutyViaDisbursement: vehicle.stampDutyViaDisbursement,
    financierEstablishmentFee,
    negativeEquityAmount,
    displayInterest: employerGRS.displayInterestRateOnDigitalEstimate,
    extendedWarrantyTerm,
    compInsurancePremiumFinanced,
    compInsuranceProvider,
  }

  const {
    vehicleAccessories = [],
    thirdPartyOption = { thirdPartyOptionLines: [] },
  } = vehicle

  const { thirdPartyOptionLines = [] } = thirdPartyOption

  const carData = {
    ...vehicle,
    luxuryCarTax: vehicle.id ? vehicle.luxuryCarTax : luxuryCarTax,
    brand,
    onRoadcost: vehicle.id ? totalOnroads : onRoadcost,
    priveawayPrice,
    amTotalExGST,
    tpoTotalExGST: vehicle.id ? tpoTotalExGST : 0,
    listedPrice: vehicle.id ? vehicle.basePrice : totalVehicleValueExGST,
    vehicleAccessoriesNames: vehicleAccessories
      ? vehicleAccessories.map((item) => item.name).join(', ')
      : null,
    accesoriesByYou: thirdPartyOptionLines
      ? thirdPartyOptionLines.map((item) => item.description).join(', ')
      : null,
    gstCreditClaimable,
    totalVehicleExGST,
    totalExGSTNoVehicle,
    totalVehicleGST: vehicle.id ? vehicle.totalVehicleGST : totalVehicleGST,
    vehicleId: vehicle.id,
    vehicleImage: vehicle.vehicleImage,
    vehicleDescription: vehicle.vehicleDescription
      ? vehicle.vehicleDescription
      : vehicleDescription,
    id,
    opportunityId,
    vehicleType: vehicle.id ? vehicle.vehicleType : vehicleType,
    isGov: false,
    shadowPR: vehicle.shadowPR,
    spartaDetail: vehicle.shadowPR ? vehicle.spartaDetail : null,
    cylinders: vehicle.vehicleCylinderConfig,
    payload: vehicle.payLoad == '0' ? null : vehicle.payLoad,
    cO2EmissionsPerKM: vehicle.cO2EmissionsPerKM,
    retailPrice: vehicle.retailPrice,
    isEvRebate: employerGRS.evRebateApplicable,
    evRebateValue: employerGRS.evRebateValue,
    evRebateTnCLink: employerGRS.evRebateLink,
  }

  const summaryData = {
    ...vehicle,
    brand,
    leaseTermYears,
    leaseTerm,
    payFrequency,
    annualRate,
    carRepaymentPerPay: isExGST
      ? carRepaymentPerPayExGST
      : carRepaymentPerPayIncGST,
    totalPackagePerPay: isExGST
      ? isTaxShare
        ? totalPackagePerPayExGSTTaxShare
        : totalPackagePerPayExGST
      : totalPackagePerPayIncGST,
    runningCostsPerPay: isExGST
      ? isTaxShare
        ? runningCostsPerPayExGSTTaxShare
        : runningCostsPerPayExGST
      : runningCostsPerPayIncGST,
    savingsPerPay,
    outOfPocketPerPay,
    fuelBudget,
    electricityBudget,
    tyresBudget,
    incidentalsBudget,
    registrationBudget,
    scheduleMaintenanceBudget,
    roadsideAssistanceBudget,
    compInsRenewalBudget,
    takeHomePerPay,
    grossSalaryPerPay,
    grossAnnualSalary,
    preTaxPerPay,
    spPreTaxDeduction,
    otherPreTaxPerPay,
    preTaxDeduction,
    taxSharePerPay,
    spTaxShareDeduction,
    netSalaryPerPay,
    netSalaryPerAnnum,
    taxMedicarePerPay,
    spTaxAndMedicare,
    netIncomePerPay,
    spNetCashSalary,
    postTaxPerPay,
    specm,
    otherPostTaxPerPay,
    postTaxDeduction,
    spCashinhand,
    lifeOfLeaseTaxSaving,
    leaseResidualAmountIncGST,
    userFirstName,
    consultantFirstName,
    vehicleDescription,
    opportunityId,
    vehicleId: vehicle.id,
    isGov: false,
    displayInterest: employerGRS.displayInterestRateOnDigitalEstimate,
    fbtPerPay,
    fbtPerAnnum,
    gstSavingsOnRunningCosts,
    productId,
    fbtMethod,
    vehicleFBTValue,
  }

  const runningData = {
    vehicle: { ...vehicle },
    compInsurancePremium,
    leaseTermYears,
    brand,
    kmPerAnnum,
    payFrequency,
    userFirstName,
    consultantFirstName,
    fuelPerPay: isExGST ? fuelPerPayExGST : fuelPerPayIncGST,
    electricityPerPay: isExGST
      ? electricityPerPayExGST
      : electricityPerPayIncGST,
    tyresPerPay: isExGST ? tyresPerPayExGST : tyresPerPayIncGST,
    roadsidePerPay: isExGST ? roadsidePerPayExGST : roadsidePerPayIncGST,
    maintenancePerPay: isExGST
      ? maintenancePerPayExGST
      : maintenancePerPayIncGST,
      incidentalsPerPay: isExGST
      ? incidentalsPerPayExGST
      : incidentalsPerPayIncGST,
    fuelPerAnnum: isExGST ? fuelPerAnnumExGST : fuelPerAnnumIncGST,
    electricityPerAnnum: isExGST
      ? electricityPerAnnumExGST
      : electricityPerAnnumIncGST,
      tyresPerAnnum: isExGST ? tyresPerAnnumExGST : tyresPerAnnumIncGST,
      roadsidePerAnnum: isExGST ? roadsidePerAnnumExGST : roadsidePerAnnumIncGST,
      maintenancePerAnnum: isExGST
        ? maintenancePerAnnumExGST
        : maintenancePerAnnumIncGST,
        incidentalsPerAnnum: isExGST
        ? incidentalsPerAnnumExGST
        : incidentalsPerAnnumIncGST,
      costsPerPay: isExGST ? costsPerPayExGST : costsPerPayIncGST,
      regoInsPerPay: isExGST ? regoInsPerPayExGST : regoInsPerPayIncGST,
      regoPerPay: regoPerPayIncGST,
    regoPerAnnum: regoPerAnnumIncGST,
    compInsPerPay: compInsPerPayIncGST,
    compInsPerAnnum: compInsPerAnnumIncGST,
    totalChargesPerPay: isExGST
      ? isTaxShare
        ? totalChargesPerPayExGSTTaxShare
        : totalChargesPerPayExGST
      : isTaxShare
      ? totalChargesPerPayIncGSTTaxShare
      : totalChargesPerPayIncGST,
      nlFeePerPay: isExGST ? nlFeePerPayExGST : nlFeePerPayIncGST,
      spFeePerPay: isExGST ? spFeePerPayExGST : spFeePerPayIncGST,
    fbtPerPay,
    lcdaPerPay,
    erSharePerPay,
    gstOnECMPerPay,
    greenfleetPerPay,
    erAdminFeePerPay,
    nlFeePerAnnum: isExGST ? nlFeePerAnnumExGST : nlFeePerAnnumIncGST,
    spFeePerAnnum: isExGST ? spFeePerAnnumExGST : spFeePerAnnumIncGST,
    fbtPerAnnum,
    lcdaPerAnnum,
    erSharePerAnnum: taxSavings,
    gstOnECMPerAnnum,
    greenfleetPerAnnum,
    erAdminFeePerAnnum,
    isExGST,
    fbtMethod,
    noOfTyresBudget,
    isTaxShare,
    isGov: false,
    fuelPricePerLitre,
    roadsideAssist,
    electricityCostPerKm,
    maintenanceProfile,
    overTheCapMethod,
    compInsuranceProvider,
    compInsurancePremiumFinanced
  }

  const bannerData = {
    nlQuoteNumber,
    userFirstName,
    brand,
    isConsultant: state.applicationRoles.isConsultant,
  }

  const endOfLeaseData = {
    ...vehicle,
    leaseResidualAmountIncGST,
    brand,
    userFirstName,
    consultantFirstName,
    year,
    make,
    family,
    vehicleId: vehicle.id,
    vehicleDescription,
    payFrequency,
    residualPCT,
    opportunityId,
    retailPrice: vehicle.retailPrice,
    priveawayPrice,
    fbtMethod,
    isIndicativeProposal,
    vehicleFBTValue,
  }

  const releaseData = {
    isRelease: false,
    /*Uncomment this line when release is enabled: channel && channel.toLowerCase() == 'release',*/
    isExistingCar: vehicle.vehicleType == 'Residual Release',
    userFirstName,
    oldOutOfPocketPerPay: currentNLOutOfPocketCostPerPay,
    outOfPocketPerPay,
  }

  return {
    accessToken,
    isAuthenticated,
    isFetching,
    opportunityId,
    carData,
    summaryData,
    endOfLeaseData,
    runningData,
    financialInclusionData,
    bannerData,
    isEstimateValid,
    estimate,
    errorMessage,
    isGov: false,
    applicationRoles,
    releaseData,
  }
}

export default connect(mapStateToProps)(withLocation(IndividualEstimateScreen))
